import classes from './DrawerToggle.module.css';

const drawerToggle = (props) => (
  <div
    className={classes.DrawerToggle}
    onClick={props.clicked}
    role="button"
    tabIndex={0}
  >
    <div />
    <div />
    <div />
  </div>
);

export default drawerToggle;
